import produce from "immer";
import { LoadState } from "../../constants/enums";
import { IStoreState } from "../initialStoreState";
import {
	initialMasterStatus,
    initialStatus,
	initialStatusState,
} from "./status.types";
import {
	FETCH_STATUS_LIST_PROGRESS,
	FETCH_STATUS_LIST_SUCCESS,
	FETCH_STATUS_LIST_FAILED,
	FETCH_STATUS_PROGRESS,
	FETCH_STATUS_SUCCESS,
	FETCH_STATUS_FAILED,
	CLEAR_STATUS_STATE,
	FETCH_MASTER_STATUS_LIST_PROGRESS,
	FETCH_MASTER_STATUS_LIST_SUCCESS,
	FETCH_MASTER_STATUS_LIST_FAILED,
	FETCH_MASTER_STATUS_PROGRESS,
	FETCH_MASTER_STATUS_SUCCESS,
	FETCH_MASTER_STATUS_FAILED,
	CLEAR_MASTER_STATUS_STATE,
} from "./statusAction";
import { error_message } from "../../constants/constants";

export const statusReducer = (
	state: IStoreState["status"] = initialStatusState,
	action: any
) => {
	switch (action.type) {
		// List Actions
		case FETCH_STATUS_LIST_PROGRESS: {
			return produce(state, (draftState) => {
				draftState.statusList.loading = LoadState.NotLoaded;
				draftState.statusList.list = [];
				draftState.statusList.totalRecords = 0;
				draftState.statusList.error = null;
			});
		}

		case FETCH_STATUS_LIST_SUCCESS: {
			const { data } = action.payload;
			return produce(state, (draftState) => {
				draftState.statusList.loading = LoadState.Loaded;
				draftState.statusList.list = data;
				draftState.statusList.error = null;
			});
		}

		case FETCH_STATUS_LIST_FAILED: {
			const { errorMessage } = action.payload;
			return produce(state, (draftState) => {
				draftState.statusList.loading = LoadState.Failed;
				draftState.statusList.error = errorMessage;
			});
		}

		// Single Status Actions
		case FETCH_STATUS_PROGRESS: {
			return produce(state, (draftState) => {
				draftState.status.loading = LoadState.InProgress;
				draftState.status.data = initialStatus;
			});
		}

		case FETCH_STATUS_SUCCESS: {
			const { data } = action.payload;
			return produce(state, (draftState) => {
				draftState.status.loading = LoadState.Loaded;
				draftState.status.data = data;
				draftState.status.error = null;
			});
		}

		case FETCH_STATUS_FAILED: {
			return produce(state, (draftState) => {
				draftState.status.loading = LoadState.Failed;
			});
		}

		case FETCH_MASTER_STATUS_LIST_PROGRESS: {
			return produce(state, (draftState) => {
				draftState.masterStatusList.loading = LoadState.NotLoaded;
				draftState.masterStatusList.list = [];
				draftState.masterStatusList.totalRecords = 0;
				draftState.masterStatusList.error = null;
			});
		}

		case FETCH_MASTER_STATUS_LIST_SUCCESS: {
			const { data } = action.payload;
			return produce(state, (draftState) => {
				draftState.masterStatusList.loading = LoadState.Loaded;
				draftState.masterStatusList.list = data;
				draftState.masterStatusList.error = null;
			});
		}

		case FETCH_MASTER_STATUS_LIST_FAILED: {
			const { errorMessage } = action.payload;
			return produce(state, (draftState) => {
				draftState.masterStatusList.loading = LoadState.Failed;
				draftState.masterStatusList.error = errorMessage;
			});
		}

		// Single Status Actions
		case FETCH_MASTER_STATUS_PROGRESS: {
			return produce(state, (draftState) => {
				draftState.masterStatus.loading = LoadState.InProgress;
				draftState.masterStatus.data = initialMasterStatus;	
			});
		}

		case FETCH_MASTER_STATUS_SUCCESS: {
			const { data } = action.payload;
			return produce(state, (draftState) => {
				draftState.masterStatus.loading = LoadState.Loaded;
				draftState.status.data = data;
				draftState.status.error = null;
			});
		}

		case FETCH_MASTER_STATUS_FAILED: {
			return produce(state, (draftState) => {
				draftState.masterStatus.loading = LoadState.Failed;
			});
		}

		case CLEAR_STATUS_STATE: {
			    return initialStatusState;
		}
		case CLEAR_MASTER_STATUS_STATE: {
			return initialStatusState;
		}

		default: {
			return state;
		}
	}
};
